import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    encuestasUsuarios: [],
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    usuario: null,
    sortByDescending: true,

    rptEncuestasUsuarios: [],

    tiposList: [],
    tiposSelectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.encuestasUsuarios = [];
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.usuario = null;
        state.sortByDescending = true;
    },

    'INICIALIZAR_ENCUESTAS' (state) {
        state.encuestasUsuarios = [];
    },
    'SET_ENCUESTAS' (state, encuestasUsuarios) {
        state.encuestasUsuarios = encuestasUsuarios;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_RPT_ENCUESTAS' (state) {
        state.rptEncuestasUsuarios = [];
    },
    'SET_RPT_ENCUESTAS' (state, rptEncuestasUsuarios) {
        state.rptEncuestasUsuarios = rptEncuestasUsuarios;
    },

    'INICIALIZAR_TIPOS_LIST' (state) {
        state.tiposList = [];
        state.tiposSelectList = [];
    },
    'SET_TIPOS_LIST' (state, tiposList) {
        state.tiposList = tiposList;
        state.tiposSelectList = tiposList.map(item => item.nombre.trim());
    },
};

const getters = {
    getField,

    rptEncuestasUsuarios: state => {
        return state.rptEncuestasUsuarios;
    },
    tiposList: state => {
        return state.tiposList;
    },
    tiposSelectList: state => {
        return state.tiposSelectList;
    }
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getEncuestas ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ENCUESTAS');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                + '&sortByDescending='+ state.sortByDescending;

            if (state.usuario) {
                if (state.usuario.id != 0) {
                    queryString += '&usuarioId=' + state.usuario.id;
                }
            }

            apiAxios.get('encuestas-usuarios' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_ENCUESTAS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, encuestaUsuarioId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`encuestas-usuarios/${encuestaUsuarioId}/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getRptEncuestas ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_ENCUESTAS');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            if (params.encuestaUsuarioTipoId) {
                if (params.encuestaUsuarioTipoId !== 0) {
                    queryString += '&encuestaUsuarioTipoId=' + params.encuestaUsuarioTipoId;
                }
            }
            if (params.usuarioId) {
                if (params.usuarioId !== 0) {
                    queryString += '&usuarioId=' + params.usuarioId;
                }
            }
            if (params.usuarioReferidoId) {
                if (paramsparams.usuarioReferidoId !== 0) {
                    queryString += '&usuarioReferidoId=' + params.usuarioReferidoId;
                }
            }
            if (params.briefId) {
                if (params.briefId !== 0) {
                    queryString += '&briefId=' + params.briefId;
                }
            }

            apiAxios.get('encuestas-usuarios/rpt' + queryString)
                .then(res => {
                    commit('SET_RPT_ENCUESTAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getTiposList: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TIPOS_LIST');

            apiAxios.get('encuestas-usuarios/encuestas-tipos/list')
                .then(res => {
                    commit('SET_TIPOS_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}